"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = setDelayedCookie;
const cookies_next_1 = require("cookies-next");
const effects_1 = require("redux-saga/effects");
const user_1 = require("../../../slices/user");
function* setDelayedCookie(user) {
    yield (0, effects_1.delay)(300);
    const values = (yield (0, effects_1.call)(cookies_next_1.getCookie, user_1.USER_COOKIE_NAME)) || '{}';
    const existentUser = JSON.parse(values);
    yield (0, effects_1.call)(cookies_next_1.setCookie, user_1.USER_COOKIE_NAME, {
        ...existentUser,
        ...user
    }, {
        maxAge: 2592000
    });
}
//# sourceMappingURL=setDelayedCookie.js.map